import { render, staticRenderFns } from "./idleTab.vue?vue&type=template&id=3521dc78&scoped=true&"
import script from "./idleTab.vue?vue&type=script&lang=js&"
export * from "./idleTab.vue?vue&type=script&lang=js&"
import style0 from "./idleTab.vue?vue&type=style&index=0&id=3521dc78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521dc78",
  null
  
)

component.options.__file = "idleTab.vue"
export default component.exports